<template>
  <div>
    <Loading v-if="initialLoad"></Loading>
    <Layout v-else>
      <div class="pt-4">
        <h3 style="font-weight: bold">Agent List</h3>
      </div>
      <section class="pt-5">
        <Overview class="overview">
          <b-col slot="total-agents">
            <b-card class="rc-card">
              <p>Total Number of Agents</p>
              <h3 style="margin-bottom: 3.75rem">
                <ICountUp
                  :delay="delay"
                  :endVal="totalNumberOfAgents"
                  :options="options"
                  @ready="getTotalNumberOfAgents"
                />
              </h3>
              <p style="font-size: 0.875rem; display: none">
                <span>+18%</span>
                <span class="grey-color pl_4">from last month</span>
              </p>
            </b-card>
          </b-col>

          <p slot="card-1-title">Pinpad Active Agents</p>
          <h3 slot="card-1-val" class="coming-soon">Coming soon</h3>

          <p slot="card-2-title">POS Active Agents</p>
          <h3 slot="card-2-val" class="coming-soon">Coming soon</h3>

          <p slot="card-4-earnings">Accounts Active Agent</p>
          <h3 slot="card-4-val" class="coming-soon">Coming soon</h3>
          <span></span>
        </Overview>
      </section>
      <section class="pt-5">
        <TransactionsList>
          <b-form-select
            class="agents-trans-select d-none"
            slot="all-agents"
            :value="options2[4]"
            :options="options2"
          ></b-form-select>
          <b-form-select
            class="agents-trans-select d-none"
            slot="all-trans"
            :value="options2[0]"
            :options="options2"
          ></b-form-select>
          <b-form-input
            slot="search-bar"
            type="search"
            placeholder="Search shown entries"
            v-model="filter"
            trim
          />
          <b-form-select
            class="show-select"
            slot="select-entry"
            value="1"
            :options="agentListEntries"
          ></b-form-select>
          <span slot="entries-no"
            >of {{ agentListEntries.length }} entries</span
          >
          <b-form-datepicker
            slot="start-date"
            id="al-start-date"
            placeholder="Start date"
            locale="en"
            class="filter-date"
            :max="today"
            @input="enableEndDate"
            v-model="startDate"
          ></b-form-datepicker>
          <b-form-datepicker
            slot="end-date"
            id="al-end-date"
            placeholder="End date"
            locale="en"
            class="filter-date"
            :disabled="disabled"
            :min="startDate"
            :max="today"
            @input="enableApply"
            v-model="endDate"
          ></b-form-datepicker>
          <b-form-input
            slot="start-range"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-input
            slot="end-range"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-input
            slot="status-input"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-checkbox
            slot="save-default"
            class="save-filter"
            id="save-filter"
          >
            Save as default filter
          </b-form-checkbox>
          <b-button
            slot="clear-btn"
            class="btn-alt filter-btn"
            block
            variant="primary"
            @click="clearFilter"
          >
            Clear
          </b-button>
          <b-button
            slot="apply-btn"
            slot-scope="{ closeModal }"
            class="filter-btn"
            block
            variant="primary"
            @click="
              closeModal();
              applyFilter();
            "
          >
            Apply
          </b-button>
          <b-table
            slot="table"
            hover
            responsive
            :items="agentListTable"
            :filter="filter"
            :empty-filtered-html="emptyImg"
            show-empty
          >
          </b-table>
        </TransactionsList>
      </section>
    </Layout>
  </div>
</template>

<script>
import moment from "moment";
import Loading from "@/components/Loading.vue";
import Layout from "@/components/Layout.vue";
import TransactionsList from "@/components/TransactionsList.vue";
import Overview from "@/components/Overview.vue";
import ICountUp from "vue-countup-v2";
import { mapState, mapActions } from "vuex";
export default {
  name: "AgentList",
  components: {
    Loading,
    Layout,
    Overview,
    ICountUp,
    TransactionsList,
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      filter: "",
      disabled: true,
      disabledApply: true,
      today: moment(Date.now()).format("YYYY-MM-DD"),
      empty: "No search result",
      emptyImg:
        "<img src=" +
        require("@/assets/icons/no-result.svg") +
        "><br> <p>No search result</p>",
      options2: [
        "Faith Bae",
        "Tosin Adarabioyo",
        "Bola Ige",
        "Babe Ruth",
        "Gad Dipupo",
        "Kemi Joseph",
      ],
    };
  },
  computed: {
    ...mapState({
      initialLoad: (state) => state.agentList.initialLoad,
      delay: (state) => state.user.delay,
      options: (state) => state.user.options,

      totalNumberOfAgents: (state) =>
        state.dashboard.dashboardData.data.total_number_agents,
      agentListTable: (state) => {
        if (state.agentList.list.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.agentList.list.data;
        }
      },
      agentListEntries: (state) => [state.agentList.list.total],
    }),
  },
  methods: {
    ...mapActions({
      getAgentList: "agentList/getAgentList",
    }),
    applyFilter() {
      console.log("Get some agent list data");
    },
    clearFilter() {
      (this.startDate = ""), (this.endDate = "");
    },
    enableEndDate() {
      this.disabled = false;
    },
    enableApply() {
      this.disabledApply = false;
    },
    getTotalNumberOfAgents(instance) {
      const that = this;
      instance.update(that.totalNumberOfAgents);
    },
  },
  created() {
    document.title = "Agent List | ReadyCash Aggregator Portal";
    this.getAgentList();
  },
};
</script>

<style lang="scss" scoped>
.agents-trans-select {
  width: 10vw;
  margin-right: 1rem;
}
.search-form input {
  border-radius: 5px;
}
</style>
